import React from "react";
import type { IndexPurchaseOrder } from "../../../api_utils/types";
import { formatMoney } from "../../../helper_functions/utils";
import { formatDateStringToMMDYY } from "../../common/CustomDatePicker/utils";
import PaymentStatusBadge from "../support/PaymentStatusBadge";
import type { paymentColumns } from "./paymentColumns";

export function PurchaseOrderPaymentCell({
  purchaseOrder,
  column,
}: {
  readonly purchaseOrder: IndexPurchaseOrder;
  readonly column: (typeof paymentColumns)[number];
}): React.ReactNode {
  if (purchaseOrder.status === "Draft") return null;

  switch (column.id) {
    case "payment_status":
    case "payment_due_date_status":
      return <PaymentStatusBadge status={purchaseOrder[column.id]} />;
    case "payment_due_date":
      return purchaseOrder.payment_due_date === null
        ? null
        : formatDateStringToMMDYY(new Date(`${purchaseOrder.payment_due_date}T00:00:00`));
    case "amount_paid":
      return purchaseOrder.amount_paid === null ? null : formatMoney(purchaseOrder.amount_paid, purchaseOrder.currency, 2);
  }
}
